import script from "./Pagenate.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pagenate.vue?vue&type=script&setup=true&lang=ts"

import "./Pagenate.vue?vue&type=style&index=0&id=0b0d3ed2&lang=css"

const __exports__ = script;

export default __exports__